<template>
	<div id="app">
		<Stein/>
	</div>
</template>

<script>
  import Stein from './components/Stein.vue'

  export default {
    name: 'App',
    components: {
      Stein
    }
  }
</script>

<style>
	#app {
		font-family: sans-serif;
	}
</style>
